import { Component, OnInit, Input, Output, EventEmitter, ElementRef, ContentChild, TemplateRef, AfterViewInit } from '@angular/core';

@Component({
  selector: 'kn-menu-button',
  templateUrl: './kraken-menu-button.component.html',
  styleUrls: ['./kraken-menu-button.component.sass']
})
export class KrakenMenuButtonComponent implements OnInit, AfterViewInit {
  @Input() buttonId: string;
  @Input() componentId: string;
  @Input() buttonText: string;
  @Input() buttonType: string;
  @Input() buttonIconLeft: string;
  @Input() disabled: boolean;
  @Input() loading: boolean;
  @Input() active = false;
  @Input() template = false;
  @Input() items: any;
  @Input() fields: any;
  @Input() contentWidth = false;
  @Input() drpdnWidth = '100%';
  @Input() dropdownCustomWidth: any;
  @Input() dropdownCustomHeight: any;
  @Input() dropdownRightAligned = false;
  @Output() isOpen = new EventEmitter<boolean>();
  @Output() btnClick = new EventEmitter<any>();
  @Output() onSelect = new EventEmitter<any>();

  public showDropdown = false;
  public topPos: string;
  public width: string;
  public height = 'auto';
  public source: object[] = [];
  public itemList: HTMLElement;
  public button;
  public rightAligned;
  public buttonTopPos;
  public leftPos;
  public dropdownElm;

  @ContentChild(TemplateRef) customTemplate: TemplateRef<any>;

  constructor(private elm: ElementRef) { }

  ngOnInit(): void {
    this.buttonId = this.buttonId ? this.buttonId : 'knButtonMenu_' + Math.floor(Math.random()*90000) + 10000;
  }

  ngAfterViewInit(): void {
    this.itemList = this.elm.nativeElement.querySelector('.kn-dropdown');
    this.button = this.elm.nativeElement.querySelector('#' + this.buttonId);
    this.dropdownElm = this.elm.nativeElement.querySelector('.kn-dropdown');

    document.addEventListener('click', (e: any) => {
      if (e.target.parentElement != this.button.parentElement && e.target !== this.dropdownElm) {
        this.showDropdown = false;
        this.isOpen.emit(false);
        e.stopPropagation();
      }
    });

    this.button.addEventListener('click', () => { 
      this.showDropdown = !this.showDropdown;
      this.isOpen.emit(this.showDropdown);

      this.popupCalc();

      //arrow navigation
      this.itemListEventListener();

    });

    window.addEventListener('scroll', () => {
      this.popupCalc();
    },true);

    window.addEventListener('resize', () => {
      this.popupCalc();
    });

    //prevent timing issue with web component
    setTimeout(() => {
      //check if custom fields are present
      this.fieldExists();
    }, 0);
  }

  fieldExists() {
    for (const key in this.items)
    {
      if(this.fields) {
        
        //check if object array has the required fields
        const indexedItem = this.items[key];
        if (Object.prototype.hasOwnProperty.call(indexedItem, this.fields.text) ) {
          const item : [] = [];
          item['text'] = indexedItem[this.fields.text];
          item['value'] = indexedItem[this.fields.value];
          item['origin'] = indexedItem;
          this.source.push(item);
        } 
      }
    }
  }

  onClick() {
		this.btnClick.emit(
      {
        id: this.buttonId,
        text: this.buttonText,
        type: this.buttonType,
        active: this.active
      });
	}

  valueChange(event) {
    this.onSelect.emit(event);
  }

  navigateItemList(e){
    const nextElm = (e.currentTarget.nextElementSibling as  HTMLElement);
    const prevElm = (e.currentTarget.previousElementSibling as  HTMLElement);
    const items = this.itemList.children;
    const itemList = Array.from(items);

    if(e.key == "ArrowDown" && nextElm) {
      nextElm.focus();
      itemList.forEach(i => {
        i.classList.remove('focus');
      });

      nextElm.classList.add('focus');
    } 

    if(e.key == "ArrowUp" && prevElm) {
      prevElm.focus();
      itemList.forEach(i => {
        i.classList.remove('focus');
      });
      prevElm.classList.add('focus');
    }

    if(e.key == "Enter") {
      e.currentTarget.click();
      e.stopImmediatePropagation();
    }
    e.preventDefault();
  }

  itemListEventListener() {
    const items = this.itemList.children;
    const itemList = Array.from(items);
    let index = 0;
    itemList.forEach(i => {
      index = index + 1;
      i.classList.remove('focus');
      i.setAttribute('tabindex', '' + index + '');
      i.addEventListener('keydown', (e) => {
        this.navigateItemList(e);
      });
    });
  }

  keydown(e) {
    if(e.key == 'ArrowDown') {
      const items = this.itemList.children;
      (items[0] as HTMLElement).focus();
    }
  }

  popupCalc() {
    const y = this.button.getBoundingClientRect().top; 
    this.width = this.button.offsetWidth + 'px';
    this.topPos = (this.button.offsetHeight + y) + 'px';
    this.drpdnWidth = this.dropdownCustomWidth ? this.dropdownCustomWidth : this.button.offsetWidth + 'px'; 
    const bottom = window.innerHeight  - y;
    const dropdownHeight = this.dropdownElm.getBoundingClientRect().height;
    if(bottom < dropdownHeight) {
      this.topPos = (y - dropdownHeight - 10) + 'px';
    } else {
      this.topPos = (this.button.offsetHeight + y) + 'px';
    }

    if(this.dropdownRightAligned) {
      this.leftPos = Math.abs(this.button.getBoundingClientRect().right - this.dropdownElm.offsetWidth) + 'px';
    } else {
      this.leftPos = this.button.getBoundingClientRect().left + 'px';
    }
  }

}
